<template>
  <v-container class="component_main pb-0 px-6 mb-0">
    <v-row class="px-3">
      <h2>Configurações</h2>
      <v-tabs v-model="tab" class="elevation-0">
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-users-list">Gestão de usuários</v-tab>
        <v-tab-item value="tab-users-list" class="pa-0">
          <UsersList
            v-show="showList"
            :selectItem="(item, action) => selectItem(item, action)"
            :filterList="(prestador, geco, search) => getList(prestador, geco, search) "
            :usersList="usersList"
            :prestadores="prestadoresList"
            :grupoEconomico="grupoEconomico"
            :permissao="{adduser, changestatususer, resetpassword, updateuser}"
            :parametrizacoes="parametrizacoes"
          />
          <UsersForm
            v-show="!showList"
            :item="selectedItem"
            :open="!showList"
            :isNew="isNew"
            :IsActive="IsActive"
            :toogleStatus="(formData) => toogleStatusConfirm(formData)"
            :resetPassword="(formData) => resetPasswordConfirm(formData)"
            :close="
              (formData) =>
                formData ? saveItem(formData) : (showList = !showList)
            "
            :genSenha="gerarSenha"
          />
        </v-tab-item>
        <!-- <v-tab href="#tab-theme-list">Gestão de estilo</v-tab>
        <v-tab-item value="tab-theme-list" class="pa-0">
          <ThemeList
            :selectItem="(item, action) => selectItem(item, action)"
            :filterList="(prestador, geco, search) => getList(prestador, geco, search) "
            :usersList="usersList"
            :prestadores="prestadoresList"
            :grupoEconomico="grupoEconomico"
            :permissao="{adduser, changestatususer, resetpassword, updateuser}"
          />
        </v-tab-item> -->
      </v-tabs>
    </v-row>
    <Footer />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Footer from "@/components/common/Footer";
import UsersForm from "@/components/config/UsersForm";
import UsersList from "@/components/config/UsersList";
// import ThemeList from "@/components/config/ThemeList";
export default {
  components: {
    Footer,
    // ThemeList,
    UsersForm,
    UsersList,
  },
  data() {
    return {
      prestadoresList: [],
      tab: null,
      isNew: true,
      IsActive: true,
      showList: true,
      selectedItem: {},
      usersList: [],
      parametrizacoes: {},
    };
  },
  created() {
    let grupoEconomico = this.$store.state.permissions.grupoEconomico
      ? this.$store.state.permissions.grupoEconomico
      : (grupoEconomico = sessionStorage.getItem("grupoEconomico"));
    this.getList(null, grupoEconomico);
    this.getParametrizacoes();
    this.$store.dispatch("permissions/getModulos", { grupoEconomico: grupoEconomico , naoParametrizaveis: true})
  },
  mounted() {
    this.prestadoresList = this.getPrestadoresByGeco()
  },
  watch: {
    grupoEconomicoList: {
      deep: true,
      handler() {
        this.prestadoresList = this.getPrestadoresByGeco()
        this.$nextTick()
      },
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData.userData,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
    }),
    ...mapGetters({
      getPrestadoresByGeco: "permissions/getPrestadoresByGeco",
    }),
    adduser(){
      return this.userData.PermissaoAcoes.portal.includes('adduser')
    },
    updateuser(){
      return this.userData.PermissaoAcoes.portal.includes('updateuser')
    },
    changestatususer(){
      return this.userData.PermissaoAcoes.portal.includes('changestatususer')
    },
    resetpassword(){
      return this.userData.PermissaoAcoes.portal.includes('resetpassword')
    },
  },
  methods: {
    getParametrizacoes() {
      let opts = {
        query: [
          {
            Modulo: "Portal",
            Acao: "getparametrizacoes",
            Payload: {
              grupo_economico: this.grupoEconomico
            },
          },
        ],
        noLoader: true,
      };
      this.$store.dispatch("request/doRequest", opts).then(resp => {
        this.parametrizacoes = resp.parametros || {};
      }).catch(err => {
        console.error('Erro ao buscar parametrizações:', err);
        this.parametrizacoes = {};
      });
    },
    selectItem(item, action) {
      switch (action) {
        case "addItem":
          this.isNew = true;
          this.IsActive = true;
          this.showList = false;
          
          break;
        case "edit":
          this.openEditUser(item);
          break;
        case "resetPwd":
          this.resetPasswordConfirm(item);
          break;
        case "toggleStatus":
          this.toogleStatusConfirm(item);
          break;

        default:
          break;
      }
    },
    openEditUser(item) {
      let obj = {
        query: [
          {
            Modulo: "portal",
            Acao: "getuser",
            Payload: {
              id: item.Id,
              grupo_economico: item.grupo_economico,
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.Erros) {
          this.$store.commit("hideLoader");
          return;
        }
        this.selectedItem = response;
        this.selectedItem.Permissao = response.Permissao //this.filterPermissao(response.Permissao);
        this.isNew = false;
        this.IsActive = response.IsActive;
        this.showList = false;
      });
    },
    filterPermissao(Permissao) {
      let filteredPermission = Object.keys(Permissao).reduce((obj, mod) => {
        let ind = Permissao[mod].indexOf("usuario")

        obj[mod] = Permissao[mod];
        if (ind > -1) {
          obj[mod].splice(ind, 1);
        }
        return obj;
      }, {});
      return filteredPermission;
    },
    unfilterPermissao(Permissao) {
      if(typeof Permissao == "string") {
        Permissao = JSON.parse(Permissao)
      }
      let obj = {};
      Object.keys(Permissao).forEach((mod) => {
        let ind = Permissao[mod].indexOf("usuario");
        if (mod == "portal" || Permissao[mod].length > 0) {
          obj[mod] = Permissao[mod];
          if (ind == -1) {
            obj[mod].push("usuario");
          }
        }
      });
      return obj;
    },
    saveItem(formData) {
      // formData.Permissao = this.unfilterPermissao(formData.Permissao);
      formData.grupo_economico = this.isNew
        ? this.grupoEconomico
        : formData.grupo_economico;
      let obj = {
        query: [
          {
            Modulo: "portal",
            Acao: this.isNew ? "adduser" : "updateuser",
            Payload: formData,
          },
        ],
      };
      
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        this.$store.commit("hideLoader");
        if (response && response.sucesso) {
          let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: response.mensagem,
            callback: () => this.getList(),
            btConfirm: { name: "Ok", show: true },
          };
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        }
      });
    },
    getList(prestador, grupoEconomico) {
      let obj = {
        query: [
          {
            Modulo: "portal",
            Acao: "getusers",
            Payload: {
              grupo_economico: grupoEconomico
                ? grupoEconomico
                : this.grupoEconomico,
              PrestadorId: prestador,
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader");
          return;
        }
        this.usersList = response.dados;
        this.showList = true;
      });
    },
    resetPasswordConfirm(selectedItem) {
      let pass = this.gerarSenha()
      let status = "copiar"
      let paramModal = {
        type: "warning",
        title: "Atenção",
        message: `Ao redefinir, a senha será <b>${pass}</b> .<br>Clique no botão para copiar. <br>Ao logar, o usuário deverá alterar a senha.<br>Deseja realmente redefinir a senha para o usuário <b>${selectedItem.Nome}</b>?`,
        callback: () => this.resetPassword(selectedItem, pass),
        btConfirm: { name: "Sim", show: true, color: "warning" },
        btCancel: { name: "Não", show: true },
        btExtra: { name: status, show: true, noShow: true, callback: () => { navigator.clipboard.writeText(pass); paramModal.btExtra.name = 'copiado'; paramModal.btExtra.color = 'green'; }}
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    resetPassword(selectedItem, pass) {
      let obj = {
        query: [
          {
            Modulo: "portal",
            Acao: "resetpassword",
            Payload: {
              Id: selectedItem.Id,
              grupo_economico: selectedItem.grupo_economico,
              senha: pass
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.erros.length) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso",
          message: response.mensagem + `<br> Copiei a senha: <b>${pass}</b>`,
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: "Não", show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    gerarSenha(){
      const alfabeto = "abcdefghijklmnopqrstuvxz";
      const letrasMinusculas = alfabeto.split('');
      const letrasMaiusculas = alfabeto
        .toUpperCase()
        .split('');
      const caracteresEspeciais = "!@#$%&*+?".split('');
      const digitos = "0123456789".split('');

      const selecionaValorAleatorioDeArray = (arraysDeOpcoes) => {
        const tamanhoDoArray = arraysDeOpcoes.length;
        const indiceAleatorio = parseInt(
          Math.random() * tamanhoDoArray
        );

        return arraysDeOpcoes[indiceAleatorio];
      };

      const selecionaValoresAleatoriosDeArray = (arraysDeOpcoes, numeroDeItens) => {
        const valoresSelecionados = [];

        for(var i = 0; i < numeroDeItens; i++) {
          const valorAleatorio = selecionaValorAleatorioDeArray(
            arraysDeOpcoes
          );

          valoresSelecionados.push(valorAleatorio);
        }

        return valoresSelecionados;
      };

      const embaralhaArray = (arrayParaEmbaralhar) => {
        const tamanhoArray = arrayParaEmbaralhar.length;
        const result = new Array(tamanhoArray);
        let posicoesDisponiveis = [];

        for(let i = 0; i < tamanhoArray; i++) {
          posicoesDisponiveis.push(i);
        }

        for(let i = 0; i < tamanhoArray; i++) {
          const conteudoItem = arrayParaEmbaralhar[i];
          const novaPosicao = selecionaValorAleatorioDeArray(posicoesDisponiveis);
          result[novaPosicao] = conteudoItem;

          const indexAlocadoParaRemoverDasPosicoesDisponiveis = posicoesDisponiveis.indexOf(novaPosicao);
          posicoesDisponiveis.splice(indexAlocadoParaRemoverDasPosicoesDisponiveis, 1);
        }

        return result;
      };

      const letraMaiscula = selecionaValorAleatorioDeArray(letrasMaiusculas);
      const caractereEspecial = selecionaValorAleatorioDeArray(caracteresEspeciais);
      const digito = selecionaValorAleatorioDeArray(digitos);
      // minimo 3 para alcancar o minimo total de 6 caracterees
      const letras = selecionaValoresAleatoriosDeArray(letrasMinusculas, 3);

      let senhaArray = [
        letraMaiscula,
        caractereEspecial,
        digito
      ];

      senhaArray = senhaArray.concat(letras);
      senhaArray = embaralhaArray(senhaArray);

      const senhaText = senhaArray.join('');
      return senhaText;
    },
    toogleStatusConfirm(selectedItem) {
      let txtWarning = selectedItem.IsActive
        ? "Ao inativar, o usuário não terá mais acesso ao sistema.<br>Essa alteração poderá ser desfeita.<br>"
        : "";
      let newStatus = selectedItem.IsActive ? "Desativar" : "Ativar";
      let paramModal = {
        type: "warning",
        title: "Atenção",
        message:
          txtWarning +
          `Deseja realmente <b>${newStatus}</b> o usuário <b>${selectedItem.Nome}</b>?`,
        callback: () => this.toogleStatus(selectedItem),
        btConfirm: { name: newStatus, show: true, color: "error" },
        btCancel: { name: "Não", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    toogleStatus(selectedItem) {
      // let newStatus = (selectedItem.IsActive)? 'BLOQUEADO' : 'ATIVADO'
      let obj = {
        query: [
          {
            Modulo: "portal",
            Acao: "changestatususer",
            Payload: {
              id: selectedItem.Id,
              isActive: !selectedItem.IsActive,
              grupo_economico: selectedItem.grupo_economico,
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso",
          message: response.mensagem,
          // message: `O usuário <b>${selectedItem.Nome}</b> foi ${newStatus} com sucesso.`,
          callback: () =>
            this.getList(null, this.$store.state.permissions.grupoEconomico),
          btConfirm: { name: "Ok", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
  },
};
</script>

<style>
</style>
